import { Color, setColor } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled, { FlattenSimpleInterpolation, css } from 'styled-components';

interface TopInfoBarContainerProps {
  isHidden?: boolean;
  hasContent?: boolean;
  barHeight: number;
  dismissible?: boolean;
  backgroundColor?: Color;
  customStyles?: FlattenSimpleInterpolation;
}

export const topInfoBarTransitionTime = 500;

export const TopInfoBarContainer = styled.div<TopInfoBarContainerProps>`
  width: 100vw;
  padding: 0.625rem 2rem;
  position: relative;
  display: grid;
  place-items: center;
  box-sizing: border-box;
  transition: margin-top ${topInfoBarTransitionTime}ms ease-in-out;
  z-index: 200;
  animation-name: slideIn;
  animation-duration: 1s;

  ${(props) => css`
    background-color: ${setColor(props.backgroundColor || 'lightTeal')};
  `}

  @keyframes slideIn {
    from {
      transform: translateY(-100%);
    }
    to {
      transform: translateY(0);
    }
  }

  ${({ hasContent }) =>
    hasContent
      ? ''
      : css`
          display: none;
        `}

  ${({ isHidden, barHeight }) =>
    !isHidden
      ? ''
      : css`
          margin-top: -${barHeight}px;
        `}

  @media screen and (max-width: ${layout.sm}) {
    padding-top: ${({ dismissible }) => (!dismissible ? '1rem' : '3rem')};
    padding-left: 1rem;
    padding-right: 1rem;
    padding-bottom: 1rem;
  }

  ${(props) => (!props.customStyles ? '' : props.customStyles)}
`;

interface DismissButtonProps {
  buttonColor?: Color;
}

export const DismissButton = styled.span<DismissButtonProps>`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0.8;
  font-size: 1rem;
  font-weight: 700;
  position: absolute;
  right: 32px;
  top: 0;
  height: 100%;
  padding: 0 8px;
  color: ${({ buttonColor }) => setColor(buttonColor || 'greyText')};

  @media screen and (max-width: ${layout.md}) {
    right: 12px;
  }

  @media screen and (max-width: ${layout.sm}) {
    height: auto;
    top: 8px;
    padding: 8px;
  }
`;
